export function resolveMyClientsAccess({ hasBillingPermission, hasMyClientsProductAccess, }) {
    return !!hasBillingPermission && hasMyClientsProductAccess;
}
